import type { Theme } from "@repo/tokens";

export const createStyles = (theme: Theme) => ({
  title: {
    ...theme.typography.headline.small.regular,
    fontWeight: 500,
  },

  description: {
    ...theme.typography.title.medium,
    letterSpacing: theme.typography.title.medium.regular.letterSpacing,
    fontWeight: 500,
    textAlign: "center",
  },
});
